import { z } from "zod";
import {
  CURRICULUM_NOTES,
  INCLUDES_3D_PRINTER,
  INCLUDES_CHAIRS,
  INCLUDES_ELECTRICAL,
  INCLUDES_PAINTING,
  INCLUDES_PODIUM_MIC,
  INCLUDES_STORAGE_CABINETS,
  INCLUDES_TABLETS,
  INCLUDES_TEACHERS_TABLE,
  INCLUDES_TV,
  INFRASTRUCTURE_NOTES,
  OTHER_NOTES,
} from "./consts";

// ✅ 1️⃣ Inventory Details schema
export const inventoryDetailsSchema = z.object({
  [INCLUDES_TV]: z.boolean().optional(),
  [INCLUDES_3D_PRINTER]: z.boolean().optional(),
  [INCLUDES_PAINTING]: z.boolean().optional(),
  [INCLUDES_ELECTRICAL]: z.boolean().optional(),
  [INCLUDES_STORAGE_CABINETS]: z.boolean().optional(),
  [INCLUDES_TEACHERS_TABLE]: z.boolean().optional(),
  [INCLUDES_PODIUM_MIC]: z.boolean().optional(),
  [INCLUDES_TABLETS]: z.boolean().optional(),
  [INCLUDES_CHAIRS]: z.boolean().optional(),

  [INFRASTRUCTURE_NOTES]: z.string().min(1, "Infrastructure Notes are required"),
  [CURRICULUM_NOTES]: z.string().min(1, "Curriculum Notes are required"),
  [OTHER_NOTES]: z.string().min(1, "Other Notes are required"),
});

// ✅ 2️⃣ Inventory Status schema
export const inventoryStatusSchema = z.object({
  packingDetails: z
    .array(
      z.object({
        id: z.string().optional(),
        packingStatus: z.string().min(1, "Packing status is required"),
        approvedBy: z.string().min(1, "Approved by is required"),
        shipmentDate: z.string().min(1, "Shipment date is required"),
        inventoryCheckLists: z.any(),
          // .min(1, "At least one checklist must be selected")
          // .optional(),
      })
    )
    .min(1, "At least one packing entry is required"),
  note: z.string().optional(),
});

// ✅ 3️⃣ Combined (only if you want one single form to validate both)
export const combinedInventorySchema = z
  .object({})
  .merge(inventoryDetailsSchema)
  .merge(inventoryStatusSchema);

// ✅ Types
export type InventoryDetailsFormValues = z.infer<typeof inventoryDetailsSchema>;
export type InventoryStatusFormValues = z.infer<typeof inventoryStatusSchema>;
export type CombinedInventoryFormValues = z.infer<typeof combinedInventorySchema>;